import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { isApiError } from '../../common/utils';

import agent from '../agent';
// import { articlePageUnloaded, createArticle, updateArticle } from './article';
// import { profilePageUnloaded } from './profile';
import { homePageUnloaded } from './subscription';
import { getUser, getMenu, magicLogin, logout, register, setToken, updateUser } from '../../Pages/Login/LoginSlice';
import { hideLoader, showLoader } from './pageLoader';

// export const appLoad = (token) => (dispatch) => {
//   dispatch(commonSlice.actions.loadApp());
//   if (token) {
//     agent.setToken(token);
//     dispatch(setToken(token));
//     dispatch(getMenu());
//     return dispatch(getUser());
//   }
// };


export const appLoad = (token) => async (dispatch) => {
  dispatch(commonSlice.actions.loadApp());

  if (!token) {
    localStorage.removeItem('user');
    dispatch(hideLoader());
    return;
  }

  agent.setToken(token);
  dispatch(setToken(token));
  dispatch(getMenu());
  dispatch(showLoader());

  try {

    
   
   
    // Remove existing "user"
    // const storedUser = localStorage.getItem('user');
    // if (storedUser) {
      
      
      
    //   const oldSub = JSON.parse(storedUser);
    //   if (oldSub?.sub_id) {
    //     // localStorage.removeItem(oldSub.sub_id);
        
         
    //   }
    // }
    localStorage.removeItem('user');
    
    const action = await dispatch(getUser());

    

    

    

    if (action.payload) {
      
      
      dispatch(hideLoader());
      const userFullName = action.payload.full_name
      const userAccNo = action.payload.account_no
      const emailAdd = action.payload.email
      // console.log(userAccNo)
      

      const userInfo = {
  full_name: userFullName,
  account_no: userAccNo,
  email: emailAdd
};
      localStorage.setItem('info', JSON.stringify(userInfo));
      const redSub = action.payload.subscription_redirection;

      

      if (redSub) {
        const sub = Array.isArray(redSub) ? redSub[0] : redSub;

        // if(!sub){
        //   localStorage.removeItem(sub.sub_id, sub.sub_number);
        // }

        // Clean up old sub_id/sub_number
        if (sub?.sub_id) {
          localStorage.removeItem(sub.sub_id);
        }
        if (sub?.sub_number) {
          localStorage.removeItem(sub.sub_number);
        }

        // Save to localStorage
        localStorage.setItem('user', JSON.stringify(sub));
        
        
        if (sub.sub_id && sub.sub_number) {
           
          localStorage.setItem(sub.sub_id, sub.sub_number);
          
  
          dispatch(hideLoader());
        }
      } else {
        
        localStorage.removeItem('user');
      }
    }
    dispatch(hideLoader());

    return action;
  } catch (error) {
    localStorage.removeItem('user');
  }
};

const initialState = {
  appName: 'ViewQwest',
  appLoaded: false,
  tokenVerified: false,
  viewChangeCounter: 0,
  redirectTo: undefined,
  user: null,
  menu: [],
  tokenIsValid: null
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    loadApp(state) {
      state.appLoaded = true;
    },
    clearRedirect(state) {
      delete state.redirectTo;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.redirectTo = '/';
    });

    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.tokenIsValid = true;
      state.tokenVerified = true;
    });

    builder.addCase(getMenu.fulfilled, (state, action) => {
      state.menu = action.payload;
      state.tokenIsValid = true;
      state.tokenVerified = true;
    });

    builder.addCase(getUser.rejected, (state, action) => {
      state.tokenIsValid = false;
      state.tokenVerified = true;
    });

    // builder.addCase(getUser.rejected, (state, action) => {
    //   state.redirectTo = "/login";
    // });

    builder.addCase(magicLogin.fulfilled, (state, action) => {
      state.redirectTo = '/';
    });

    builder.addCase(register.fulfilled, (state, action) => {
      state.redirectTo = '/';
    });

    builder.addCase(logout, (state) => {
      state.redirectTo = '/';
    });

    // builder.addCase(createArticle.fulfilled, (state, action) => {
    //   state.redirectTo = `/article/${action.payload.article.slug}`;
    // });

    // builder.addCase(updateArticle.fulfilled, (state, action) => {
    //   state.redirectTo = `/article/${action.payload.article.slug}`;
    // });

    builder.addMatcher(
      (action) => [homePageUnloaded.type].includes(action.type),
      (state) => {
        state.viewChangeCounter++;
      }
    );
  }
});

export const { clearRedirect } = commonSlice.actions;

export const selectUser = (state) => state.user;

export const getPostalCode = createAsyncThunk('getPostalCode', async (data, thunkApi) => {
  try {
    const response = await agent.SGLocate.get(data);
    return response;
  } catch (error) {
    if (isApiError(error)) {
      return thunkApi.rejectWithValue(error);
    }
    throw error;
  }
});

export default commonSlice.reducer;
